/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ForwardRefExoticComponent, RefAttributes } from 'react'
import type { ControllerRenderProps } from 'react-hook-form'
import type { BranchForForm } from 'types'

import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { FormControl, InputGroup } from 'components'

interface IRenderFormControlOption {
  className?: string
  name: string
  label: string
  htmlFor?: string
  type?: 'text'
  placeholder?: string
  tooltip?: string
  required?: boolean
  render?: (field: ControllerRenderProps) => JSX.Element
  asRef?: ForwardRefExoticComponent<any & RefAttributes<HTMLTextAreaElement>>
  isInputGroup?: boolean
  hasCountable?: boolean
  errorMsg?: string
  maxLength?: number
  fullWidth?: boolean
}

export const InputFormControl: React.FC<IRenderFormControlOption> = ({
  className,
  name,
  label,
  htmlFor = '',
  tooltip,
  type = '',
  placeholder,
  required,
  hasCountable,
  render,
  asRef,
  isInputGroup,
  errorMsg,
  maxLength,
  fullWidth,
}) => {
  const { control } = useFormContext<BranchForForm>()

  if (isInputGroup) {
    return (
      <FormControl
        className={className}
        label={label}
        required={required}
        htmlFor={htmlFor}
      >
        <InputGroup error={errorMsg} variants='secondary'>
          {render && (
            <Controller
              control={control}
              name={name}
              render={render}
              placeholder={placeholder}
              hasCountable={hasCountable}
              maxLength={maxLength}
              fullWidth={fullWidth}
            />
          )}
        </InputGroup>
      </FormControl>
    )
  }

  return (
    <FormControl
      className={className}
      label={label}
      required={required}
      htmlFor={htmlFor}
      tooltip={tooltip}
    >
      {render && (
        <Controller
          type={type}
          name={name}
          control={control}
          render={render}
          placeholder={placeholder}
          hasCountable={hasCountable}
          maxLength={maxLength}
          fullWidth={fullWidth}
        />
      )}

      {asRef && (
        <Controller
          as={asRef}
          name='detail'
          control={control}
          placeholder={placeholder}
          hasCountable
          maxLength={maxLength}
          fullWidth={fullWidth}
        />
      )}
    </FormControl>
  )
}
